module.exports = __webpack_public_path__ + "static/media/Resume.d66e01a7.pdf";